import React, { useState } from 'react';

const ACCOUNTS = [
  { code: '1000', name: 'Cash', type: 'Asset', balance: 45200.00 },
  { code: '1100', name: 'Accounts Receivable', type: 'Asset', balance: 12800.00 },
  { code: '1200', name: 'Inventory', type: 'Asset', balance: 33500.00 },
  { code: '1500', name: 'Fixed Assets', type: 'Asset', balance: 120000.00 },
  { code: '2000', name: 'Accounts Payable', type: 'Liability', balance: 8400.00 },
  { code: '2100', name: 'Short-term Loans', type: 'Liability', balance: 15000.00 },
  { code: '3000', name: 'Owner Equity', type: 'Equity', balance: 188100.00 },
  { code: '4000', name: 'Sales Revenue', type: 'Revenue', balance: 95000.00 },
  { code: '4100', name: 'Service Revenue', type: 'Revenue', balance: 12000.00 },
  { code: '5000', name: 'Cost of Goods Sold', type: 'Expense', balance: 47000.00 },
  { code: '5100', name: 'Salaries Expense', type: 'Expense', balance: 18000.00 },
  { code: '5200', name: 'Rent Expense', type: 'Expense', balance: 6000.00 },
];

const PIE_COLORS = ['#6366f1', '#10b981', '#f59e0b', '#ef4444', '#3b82f6'];
const TYPES = ['All', 'Asset', 'Liability', 'Equity', 'Revenue', 'Expense'];

const typeColor = (type) => {
  const map = { Asset: '#6366f1', Liability: '#ef4444', Equity: '#10b981', Revenue: '#3b82f6', Expense: '#f59e0b' };
  return map[type] || '#64748b';
};

const typeBadge = (type) => {
  const map = { Asset: 'acc-badge-blue', Liability: 'acc-badge-red', Equity: 'acc-badge-green', Revenue: 'acc-badge-blue', Expense: 'acc-badge-yellow' };
  return map[type] || 'acc-badge-gray';
};


const ChartOfAccounts = () => {
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [showModal, setShowModal] = useState(false);
  const [accounts, setAccounts] = useState(ACCOUNTS);
  const [form, setForm] = useState({ code: '', name: '', type: 'Asset', balance: '' });

  const filtered = accounts.filter(a =>
    (filterType === 'All' || a.type === filterType) &&
    (a.name.toLowerCase().includes(search.toLowerCase()) || a.code.includes(search))
  );

  const typeGroups = TYPES.slice(1).map(t => ({
    label: t,
    value: accounts.filter(a => a.type === t).reduce((s, a) => s + a.balance, 0),
  })).filter(g => g.value > 0);

  const handleAdd = () => {
    if (!form.code || !form.name) return;
    setAccounts(prev => [...prev, { ...form, balance: parseFloat(form.balance) || 0 }]);
    setForm({ code: '', name: '', type: 'Asset', balance: '' });
    setShowModal(false);
  };

  return (
    <div className="accounting-page">
      <div className="table-controls">
        <div className="table-controls-left">
        </div>
        <div className="table-controls-right">
          <div className="tabs-search-wrapper">
            <input
              className="tabs-search-input"
              placeholder="Search accounts..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <select
              className="form-select"
              value={filterType}
              onChange={e => setFilterType(e.target.value)}
              style={{ minWidth: '130px', height: '38px', padding: '0.4rem 0.6rem', fontSize: '0.875rem', border: '1px solid #e2e8f0', borderRadius: '8px' }}
            >
              {TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
          <button className="control-btn-primary" onClick={() => setShowModal(true)}>
            <span className="plus-icon">+</span> Add Account
          </button>
        </div>
      </div>

      <div className="table-content-card">
        <div className="coa-list-fullwidth">
          <h3 className="acc-card-title">Account List</h3>
          <div style={{ width: '100%' }}>
            <table className="coa-table" style={{ width: '100%' }}>
              <thead>
                <tr><th>Code</th><th>Account Name</th><th>Type</th><th style={{ textAlign: 'right' }}>Balance</th></tr>
              </thead>
              <tbody>
                {filtered.map(a => (
                  <tr key={a.code}>
                    <td><span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{a.code}</span></td>
                    <td>{a.name}</td>
                    <td><span className={`acc-badge ${typeBadge(a.type)}`}>{a.type}</span></td>
                    <td style={{ textAlign: 'right', fontWeight: 600 }}>${a.balance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={4}><div className="acc-empty"><div className="acc-empty-icon">📂</div><h4>No accounts found</h4></div></td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-container filter-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add Account</h3>
              <button className="modal-close-btn" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-content">
              <div className="acc-form-grid">
                <div className="acc-form-group">
                  <label>Account Code</label>
                  <input value={form.code} onChange={e => setForm(p => ({ ...p, code: e.target.value }))} placeholder="e.g. 1050" />
                </div>
                <div className="acc-form-group">
                  <label>Account Name</label>
                  <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="e.g. Petty Cash" />
                </div>
                <div className="acc-form-group">
                  <label>Type</label>
                  <select value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}>
                    {TYPES.slice(1).map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="acc-form-group">
                  <label>Opening Balance</label>
                  <input type="number" value={form.balance} onChange={e => setForm(p => ({ ...p, balance: e.target.value }))} placeholder="0.00" />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn close-btn" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="modal-btn primary-btn" onClick={handleAdd}>Add Account</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartOfAccounts;
